import { currencyInput } from '@/_schemas/generic';

import { campaignTypesOptions, type MarketingCampaignFormSchema } from '../schemas';

export const defaultValues: Readonly<MarketingCampaignFormSchema> = {
  id: -1,
  name: '',
  campaign_type: campaignTypesOptions[0],
  date: '',
  attached_files: [],
  notes: '',
  total_cost_of_campaign: currencyInput.defaultValue(),
  clients: [],
  contacts: [],
};
